import React, { useEffect, useState } from "react";
import {
  payout_banklimit_get,
  usePayoutListBankLimit,
} from "../../../redux/slices/payinPayoutSlice";
import { Card } from "reactstrap";
import { Table, TableRow } from "../../../components/Table";
import { useDispatch, useSelector } from "react-redux";
import { seperator, sortByTodataWithdraw } from "../../../helperFunctions";
import PayOutBankAmount from "./PayOutBankAmount";
import { ProgressBar } from "../../../components/Custom/Elements/ProgressBar/ProgressBar";
import { TRA_FILTER, TRA_PAGINATION_OPTIONS } from "../../../constant";
import { useAutoRefreshTime, useRole } from "../../../redux/slices/authSlice";

const PayOutBankLimit = ({ refresh }) => {
  const { getPayoutbanklimitLoading } = useSelector(
    (state) => state.payinPayout
  );
  const dispatch = useDispatch();
  const [updateDetails, setUpdateDetails] = useState({});
  const getPayoutListBankLimitState = usePayoutListBankLimit();
  const [filter, setFilter] = useState(TRA_FILTER);
  const [isLoading, setIsLoading] = useState(false);

  const [filterPayoutbanklimitColumns, setFilterPayoutbanklimitColumns] =
  useState([]);
  const autoRefreshTime = useAutoRefreshTime();
  const role = useRole("Bank Limit");

  const payoutbanklimitColumns = [
    {
      title: "LABEL",
      name: "pg_label",
      Cell: (data) => {
        return (
          <>
            <span>
              {data?.pg_label}{" "}
              <span style={{ color: "#888888", fontSize: "12px" }}>
                ({data?.account_id})
              </span>
            </span>
          </>
        );
      },
    },
    {
      title: "PG",
      name: "activemeta",
    },
    {
      title: "AC NUMBER",
      name: "account_number",
    },
    {
      title: "BANK NAME",
      name: "bank_name",
    },
    {
      title: "DAILY LIMIT",
      name: "daily_limit",
      Cell: (data) => {
        return (
          <>
            {role.includes("update-withdrawal-bank-limit") ?
              <PayOutBankAmount
                updateDetails={updateDetails}
                setUpdateDetails={setUpdateDetails}
                data={data}
                PayoutBanklimitGet={() => {
                  PayoutBanklimitGet(true);
                }}
                setIsLoading={setIsLoading}
              />
              : <span>
                {data?.daily_limit}
              </span>}
          </>
        );
      },
    },
    // {
    //   title: "CURRENT TURNOVER",
    //   name: "current_turnover",
    //   Cell: (data) => {
    //     const per =
    //       (+data?.merchant_payout_meta?.current_turnover / +data?.daily_limit) *
    //         100 || 0;
    //     return (
    //       <>
    //         <span style={{ color: per > 79 ? "red" : "" }}>
    //           {seperator(data?.merchant_payout_meta?.current_turnover, false)}
    //         </span>
    //       </>
    //     );
    //   },
    // },
    {
      title: "PENDING LIMIT",
      name: "pending_limit",
      Cell: (data) => {
        const pendingLimit =
          data?.daily_limit - data?.merchant_payout_meta?.current_turnover;
        return (
          <>
            <span
              style={{
                color: pendingLimit < 0 ? "ff5757" : "black",
              }}
            >
              {seperator(pendingLimit)}
            </span>
          </>
        );
      },
    },
    // {
    //   title: "LIMIT(%)",
    //   name: "pending_limit",
    //   Cell: (data) => {
    //     const pendingLimit =
    //       data?.daily_limit - data?.merchant_payout_meta?.current_turnover || 0;
    //     const todata =
    //       (+data?.merchant_payout_meta?.current_turnover / +data?.daily_limit) *
    //       100 || 0;
    //     const progressPer =
    //       (data?.daily_limit < data?.merchant_payout_meta?.current_turnover ||
    //         data?.daily_limit == data?.merchant_payout_meta?.current_turnover)
    //         ? 0
    //         : todata > 100
    //           ? 100
    //           : todata < 0
    //             ? 0
    //             : todata;

    //     return (
    //       <>
    //         <div className="position-relative" style={{width:"170px"}}>
    //           <Box sx={{ flexGrow: 1 }}>
    //             <LinearProgress
    //               sx={{
    //                 height: 20,
    //                 borderRadius: 1,
    //                 backgroundColor:
    //                   (data?.daily_limit < data?.merchant_payout_meta?.current_turnover ||
    //                     data?.daily_limit == data?.merchant_payout_meta?.current_turnover)
    //                     ? "#ff5757"
    //                     : "#5195d8ed",
    //               }}
    //               variant="determinate"
    //               value={progressPer}
    //             />
    //           </Box>
    //           <div
    //             style={{ fontSize: "12px" }}
    //             className="progress-position text-center"
    //           >
    //             <span style={{ color: "white" }}>
    //               {(data?.daily_limit < data?.merchant_payout_meta?.current_turnover ||
    //                 data?.daily_limit == data?.merchant_payout_meta?.current_turnover)
    //                 ? 100
    //                 : todata < 0
    //                   ? 100
    //                   : progressPer.toFixed(2)}
    //               %
    //             </span>
    //           </div>
    //         </div>
    //         <div style={{ fontSize: "12px" }}>
    //           {seperator(pendingLimit, false)} pending of{" "}
    //           {seperator(data?.daily_limit, false)}
    //         </div>
    //       </>
    //     );
    //   },
    // },
    {
      title: "LIMIT(%)",
      name: "pending_limit",
      Cell: (data) => {
        const pendingLimit =
          (+data?.daily_limit || 0) - (+data?.current_turnover || 0);
        const todata =
          (+data?.merchant_payout_meta?.current_turnover / +data?.daily_limit) *
          100 || 0;

        return (
          <div className="position-relative">
            <ProgressBar
              done={todata}
              pendingLimit={pendingLimit}
              dailyLimit={data?.daily_limit}
            />
          </div>
        );
      },
    },
  ];

  const PayoutBanklimitGet = async (loading = false) => {
    try {
      if (loading) {
        setIsLoading(true);
      }

      const { isFilter, ...rest } = filter;
      const payload = {
        ...rest,
      };

      await dispatch(payout_banklimit_get(payload)).unwrap();
    } catch (err) { }
  };

  useEffect(() => {
    const newColumns = payoutbanklimitColumns?.map((item) => item?.name);
    setFilterPayoutbanklimitColumns(newColumns);
  }, []);

  useEffect(() => {
    if (role.includes("withdrawal-bankLimit-list")) {
      PayoutBanklimitGet();
    }
  }, [filter]);

  useEffect(() => {
    if (role.includes("withdrawal-bankLimit-list")) {
      const IntervalClick = setInterval(() => {
        if (refresh) {
          PayoutBanklimitGet(false);
        }
      }, autoRefreshTime);
      return () => clearInterval(IntervalClick);
    }
  }, [refresh, filter]);

  if (!role.includes("withdrawal-bankLimit-list")) {
    return;
  }

  return (
    <div
      className={`${getPayoutbanklimitLoading && refresh ? "opacity-25" : ""}`}
    >
      <Card>
        <Table
          columns={payoutbanklimitColumns}
          isLoading={(getPayoutbanklimitLoading || isLoading) && !refresh}
          data={getPayoutListBankLimitState?.data || []}
          isData={!!getPayoutListBankLimitState?.data?.length}
          filterColumns={filterPayoutbanklimitColumns}
          count={getPayoutListBankLimitState?.total_item || 0}
          pagination={filter}
          isExpandable={false}
          handlePaginationChange={(pagination) => {
            setFilter({
              ...filter,
              ...pagination,
            });
          }}
          onColumnsChange={(columns) => {
            setFilterPayoutbanklimitColumns(columns);
          }}
          paginationOptions={TRA_PAGINATION_OPTIONS}
        >
          {sortByTodataWithdraw(getPayoutListBankLimitState?.data || [])?.map(
            (item) => {
              return (
                <TableRow
                  columns={payoutbanklimitColumns}
                  item={item}
                  filterColumns={filterPayoutbanklimitColumns}
                  isExpandable={false}
                />
              );
            }
          )}
        </Table>
      </Card>
    </div>
  );
};

export default PayOutBankLimit;
